"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const react_1 = __importDefault(require("react"));
require("./Spinner.scss");
// http://tobiasahlin.com/spinkit/
const Spinner = (props) => {
    var _a;
    return (react_1.default.createElement("div", { ...props, className: "sk-circle " + ((_a = props.className) !== null && _a !== void 0 ? _a : "") },
        react_1.default.createElement("div", { className: "sk-circle1 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle2 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle3 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle4 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle5 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle6 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle7 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle8 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle9 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle10 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle11 sk-child" }),
        react_1.default.createElement("div", { className: "sk-circle12 sk-child" })));
};
exports.Spinner = Spinner;
